import React from "react";
import { StyledBreadcrumb } from "./styles";

const Breadcrumb = (props) => {
  return <StyledBreadcrumb icon="right angle" sections={props.sections} />;
};

export default Breadcrumb;
